






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {ResponsavelConfigSms} from '@/model/resource/ResponsavelConfigSms'
import {InputResponsavelConfigSmsSchema} from '@/schema/resource/ResponsavelConfigSms/InputResponsavelConfigSmsSchema'

@Component
export default class PersistResponsavelConfigSmsView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputResponsavelConfigSmsSchema()
  responsavelConfigSms = new ResponsavelConfigSms()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.responsavelConfigSms.getResponsavelConfigSms(id)
    }

    $.await.done('getResponsavelConfigSms')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.responsavelConfigSms.persistResponsavelConfigSms()
    await Helper.successAndPush(
      'system.success.persist',
      '/responsavel-config-sms/list'
    )
  }
}
